export default {
	project: {
		my_xs: '自分の意思決定',
		fields: {
			name: 'タイトル',
			name_explanation: 'プロジェクトのタイトルを入力してください',
			description: 'ミッション',
			description_explanation: '全体のミッションを記述してください',
			vision: 'ビジョン',
			vision_explanation: 'プロジェクトの長期的なビジョンを記述してください',
			description_long: '説明',
			description_long_explanation: '例：「スイスのメカトロニクスSME、200人、欧州自動車OEM市場。ミッション：2030年までにスマートセンサーの欧州リーダーになる。」',
			description_long_hint: '説明が具体的であるほど（業界、規模、ミッション）、分析の精度が高まります。',
			description_long_warning_title: '説明が簡潔です',
			description_long_warning_body: '説明は{{count}}文字です。AIが組織と一致しない業界や文脈を推測する可能性があります。実行前に内容を充実させますか？',
			description_long_warning_enrich: '充実させる',
			description_long_warning_continue: 'このまま実行',
			ai_context: '特定の焦点と切り口',
			ai_context_explanation: '分析が優先すべき切り口、アクター、制約を指定してください（例：特定の競合、規制面、地域、時間的制約など）。',
			fishbone_description: '戦略計画 - あるべき姿',
			fishbone_description_explanation: '',
			reference: '参照',
			tags: 'タグ',
			likelihoods: '発生可能性',
			impacts: '影響',
			types: {
				stakeholders: 'ステークホルダー',
				stakeholders_long: 'ステークホルダープロジェクト',
				stakeholders_explanation: '関係する力を整合させる',
				risks: 'リスク',
				risks_long: 'リスクプロジェクト',
				risks_explanation: 'リスクを突破口へ転換する',
				pro: '戦略実行',
				pro_long: '戦略実行プロジェクト',
				pro_explanation: '俊敏に実行する'
			},
			ai: {
				scenarios: {
					title: "検討するシナリオ",
					hint: "プライベートAIで処理 — 外部への情報送信なし。テキスト、期間、追加・削除を編集できます。",
					worst_label: "最悪のケース",
					worst_default: "主要リスクが顕在化し、機会を逃し、ステークホルダーが反対。",
					best_label: "最良のケース",
					best_default: "リスクが制御され、機会を捉え、ステークホルダーが協力。",
					add: "シナリオを追加",
					remove: "このシナリオを削除",
					label_placeholder: "シナリオ名",
					content_placeholder: "仮説、主要イベント、実現条件…"
				},
				horizon_unit: {
					d: "日",
					w: "週",
					m: "カ月",
					y: "年"
				}
			},
		},
		messages: {
			delete_confirmation: 'プロジェクトを削除',
			delete_confirmation_explanation:
				'プロジェクト「{{name}}」を削除してもよろしいですか？この操作は取り消せません。',
			clone_confirmation: 'プロジェクトを複製',
			clone_confirmation_explanation:
				'このプロジェクトを複製してもよろしいですか？',
			clone_in_progress: 'プロジェクトを複製しています。お待ちください…',
			delete_in_progress: 'プロジェクトを削除しています。お待ちください…'
		},
		actions: {
			edit: 'プロジェクト詳細を編集',
			delete: 'プロジェクトを削除',
			clone: 'プロジェクトを複製',
			open: 'プロジェクトを開く'
		}
	},
	option: {
		fields: {
			name_explanation: 'このオプションの名前を入力してください'
		}
	},
	item: {
		name: 'ステークホルダー',
		name_plural: 'ステークホルダー',
		activeness_zones: {
			external_outer_positive: '中立',
			external_inner_positive: '非活動',
			external_outer_negative: '中立',
			external_inner_negative: '非活動',

			internal_low_positive: '低',
			internal_medium_positive: '中',
			internal_high_positive: '高',
			internal_low_negative: '低',
			internal_medium_negative: '中',
			internal_high_negative: '高',

			internal_positive: '触媒',
			internal_negative: '阻害要因'
		},
		messages: {
			delete_confirmation: 'ステークホルダーを削除',
			delete_confirmation_explanation:
				'このステークホルダーを削除してもよろしいですか？この操作は取り消せず、すべてのシナリオに影響します。\n\nこのシナリオだけ非表示にしたい場合は閉じ、ステークホルダーを選択し、右列の「目」アイコンでこのシナリオのみ無効にしてください。'
		},
		fields: {
			name: '名前',
			description: '説明',
			links: {
				outcoming: {
					name: '出力リンク'
				},
				incoming: {
					name: '入力リンク'
				}
			},
			stakes: {
				name: 'ステークとの関係'
			},
			indicators: {
				name: '指標との関係'
			},
			risks: {
				name: 'リスクとの関係'
			},
			opportunities: {
				name: '突破口との関係'
			},
			impact: {
				label: '重要度',
				level: {
					low: '低',
					medium: '中',
					high: '高'
				}
			},
			trend: {
				label: 'トーン',
				level: {
					green: '前向き',
					neutral: '中立',
					orange: 'リスクあり',
					red: 'ネガティブ'
				}
			}
		},
		actions: {
			create_new: '新しいステークホルダーを作成',
			edit: '詳細を編集',
			delete: 'ステークホルダーを削除',
			clone: 'ステークホルダーを複製'
		},
		no_x: 'ステークホルダーなし',
		engagement: 'エンゲージメント',
		importance: '重要度',
		trust: 'トーン',
		levels: {
			low: '低',
			medium: '中',
			high: '高',
			inactive_neutral: '非活動 / 中立',
			positive: '前向き',
			positive_short: '前向',
			negative: 'ネガティブ',
			negative_short: 'ネガ',
			at_risk: 'リスクあり',
			neutral: '中立'
		}
	},
	item_link: {
		no_x: 'リンクなし',
		actions: {
			create_new: '新しいリンクを作成'
		}
	},
	item_comment: {
		no_x: '履歴なし',
		actions: {
			create_new: '新しい履歴を作成'
		}
	},
	tag: {
		name: 'タグ',
		name_plural: 'タグ',
		fields: {
			name: 'タグ',
			name_plural: 'タグ'
		},
		messages: {
			delete_confirmation: 'タグを削除',
			delete_confirmation_explanation:
				'このタグを削除してもよろしいですか？この操作は取り消せません。',
			no_x: 'タグなし'
		},
		actions: {
			add_x: 'タグを追加',
			create_new: 'タグを作成',
			edit: 'タグを編集',
			delete: 'タグを削除'
		}
	},
	stake: {
		no_x: 'ステークなし',
		name: 'ステーク',
		name_plural: 'ステーク',
		fields: {
			name: '名前',
			reference: '参照',
			name_plural: 'ステーク',
			description: '説明',
			evaluated_at: '最終評価',
			weight: '重み',
			trend: '状態',
			risks: {
				name: 'リスクとの関係',
				name_positive: '突破口との関係'
			},
			trend_tier: {
				strained: '不安定',
				mixed: '混在',
				solid: '堅牢'
			}
		},
		message: {
			no_x: 'ステークなし'
		},
		messages: {
			delete_confirmation: 'ステークを削除',
			delete_confirmation_explanation:
				'このステークを削除してもよろしいですか？この操作は取り消せず、すべてのシナリオに影響します。\n\nこのシナリオだけ非表示にしたい場合は閉じ、ステークを選択し、右列の「目」アイコンでこのシナリオのみ無効にしてください。'
		},
		actions: {
			delete: 'ステークを削除',
			edit: 'ステークを編集',
			create_new: 'ステークを作成'
		}
	},

	indicator: {
		name: '指標',
		name_plural: '指標',
		no_x: '指標なし',
		fields: {
			indicator_category: 'カテゴリー',
			name: '名前',
			reference: '参照',
			name_plural: '指標',
			evaluated_at: '最終評価',
			frequency: '頻度',
			weight: '重み',
			description: '説明'
		},
		action: {
			add_x: '指標ポイントを追加'
		},
		message: {
			no_x: '指標なし'
		},
		messages: {
			delete_confirmation: '指標を削除',
			delete_confirmation_explanation:
				'この指標を削除してもよろしいですか？この操作は取り消せず、すべてのシナリオに影響します。\n\nこのシナリオだけ非表示にしたい場合は閉じ、指標を選択し、右列の「目」アイコンでこのシナリオのみ無効にしてください。'
		},
		actions: {
			delete: '指標を削除',
			edit: '指標を編集',
			create_new: '指標を作成'
		}
	},

	scenario: {
		name: 'シナリオ',
		name_plural: 'シナリオ',
		no_x: 'シナリオなし',
		baseline: 'ベースライン',
		fields: {
			name: '名前',
			name_long: 'シナリオ名',
			score: 'シナリオスコア',
			description: '説明',
			impacts: '影響の説明',
			generate_simulation: 'シミュレーションを自動生成',
			simulation_query: '仮説と時間軸'
		},
		placeholders: {
			simulation_query:
				'例：2年以内に原油価格が50%上昇した場合は？ステークホルダーと特定したリスクへの影響は？'
		},
		messages: {
			delete_confirmation: 'シナリオを削除',
			delete_confirmation_explanation:
				'このシナリオを削除してもよろしいですか？この操作は取り消せません。',
			switch_scenario: 'ベースラインまたは別のシナリオに切り替え',
			creation_in_progress:
				'シナリオの準備中です。しばらくお待ちください…',
			simulation_explanation:
				'AIが仮説を分析し、シナリオをシミュレートするためにステークホルダー、リスク、ステークの変更を提案します。',

			promote_as_baseline: {
				title: 'このシナリオを新しいベースラインに昇格',
				explanation:
					'シナリオ「<0>{{name}}</0>」を新しいベースラインに昇格してもよろしいですか？この操作は取り消せません。',
				keep_current_baseline_as_scenario_question:
					'以前のベースラインをどうしますか？',
				keep_current_baseline_as_scenario_question_yes:
					'保持し、次の名前を付ける',
				keep_current_baseline_as_scenario_question_no:
					'不要。削除してよい',
				keep_scenario_question:
					'新ベースラインに昇格したシナリオのコピーを残しますか？',
				keep_scenario_question_yes: 'はい、コピーを残す',
				keep_scenario_question_no: 'いいえ、不要',
				loading: 'ベースラインに昇格しています…'
			},

			best_evaluation: '全シナリオのうち最良の評価'
		},
		actions: {
			create_new: '新しいシナリオを作成',
			create_new_from_baseline: 'ベースラインから新しいシナリオを作成',
			save_as_new_baseline: '新しいベースラインとして保存',
			clone: 'シナリオを複製',
			edit: 'シナリオを編集',
			delete: 'シナリオを削除',
			next: '次のシナリオへ',
			previous: '前のシナリオへ',
			previous_baseline: 'ベースラインへ'
		}
	},
	fishbone_branch: {
		name: '骨',
		name_plural: '骨',
		fields: {
			completion: '進捗',
			trend: '状態',
			name: '名前',
			description: '説明',
			weight: '重み',
			responsible: '担当',
			dates: '日付',
			startOn: '開始',
			endOn: '終了'
		},
		messages: {
			delete_confirmation: 'フィッシュボーンの枝を削除',
			delete_confirmation_explanation:
				'この枝を削除してもよろしいですか？この操作は取り消せず、すべてのシナリオに影響します。\n\nこのシナリオだけ非表示にしたい場合は閉じ、枝を選択し、右列の「目」アイコンでこのシナリオのみ無効にしてください。'
		},
		actions: {
			add: '骨を追加',
			clone: '骨を複製',
			edit: '骨を編集',
			delete: '骨を削除'
		}
	},
	fishbone_item: {
		name: 'サブ骨',
		name_plural: 'サブ骨',
		fields: {
			name: '名前',
			description: '説明',
			completion: '進捗',
			trend: '状態',
			weight: '重み',
			responsible: '担当',
			startOn: '開始',
			endOn: '終了',
			dates: '日付'
		},
		messages: {
			delete_confirmation: 'サブ骨を削除',
			delete_confirmation_explanation:
				'この施策を削除してもよろしいですか？この操作は取り消せず、すべてのシナリオに影響します。\n\nこのシナリオだけ非表示にしたい場合は閉じ、施策を選択し、右列の「目」アイコンでこのシナリオのみ無効にしてください。'
		},
		actions: {
			add: 'サブ骨を追加',
			clone: 'サブ骨を複製',
			edit: 'サブ骨を編集',
			delete: 'サブ骨を削除'
		}
	},
	risk: {
		name: 'リスク',
		name_plural: 'リスク',
		name_positive: '突破口',
		name_plural_positive: '突破口',
		fields: {
			name: '名前',
			description: '説明 - 発生を示す指標',
			reference: '参照',
			risk_category: 'カテゴリ',
			likelihood: '発生可能性',
			likelihood_level: '発生可能性レベル名',
			impact: '影響',
			impact_level: '影響レベル名',
			matching_opportunity: '対応する突破口',
			matching_risks: '関連リスク',
			evaluated_at: '最終評価',
			exposure: 'エクスポージャー',
			exposure_positive: 'アップサイド',

			opportunity: {
				name: '突破口'
			}
		},
		impacts: {
			1: '無視できる',
			2: '軽微',
			3: '中程度',
			4: '重大',
			5: '極大'
		},
		likelihoods: {
			1: '極めて低い',
			2: '低い',
			3: 'あり得る',
			4: '高い',
			5: 'ほぼ確実'
		},

		messages: {
			delete_confirmation: 'リスクを削除',
			delete_confirmation_explanation:
				'このリスクを削除してもよろしいですか？この操作は取り消せず、すべてのシナリオに影響します。\n\nこのシナリオだけ非表示にしたい場合は閉じ、リスクを選択し、右列の「目」アイコンでこのシナリオのみ無効にしてください。',
			delete_opening: '突破口を削除',
			delete_opening_explanation:
				'この突破口を削除してもよろしいですか？この操作は取り消せず、すべてのシナリオに影響します。\n\nこのシナリオだけ非表示にしたい場合は閉じ、突破口を選択し、右列の「目」アイコンでこのシナリオのみ無効にしてください。',
			no_x: 'リスクなし',
			no_category: 'カテゴリなし',
			no_x_positive: '突破口なし'
		},
		actions: {
			create_new: '新しいリスクまたは突破口を作成',
			edit: 'リスクを編集',
			edit_opportunity: '突破口を編集',
			delete: 'リスクを削除',
			delete_opportunity: '突破口を削除'
		}
	},
	risk_category: {
		name: 'カテゴリ',
		name_plural: 'カテゴリ',
		fields: {
			name: '名前'
		},
		messages: {
			delete_confirmation: 'カテゴリを削除',
			delete_confirmation_explanation:
				'このカテゴリを削除してもよろしいですか？この操作は取り消せません。',
			no_x: 'カテゴリなし'
		},
		default_values: {
			name: {
				1: '存続',
				2: '戦略',
				3: 'オペレーション'
			}
		},
		actions: {
			create_new: '新しいカテゴリを作成',
			edit: 'カテゴリを編集',
			delete: 'カテゴリを削除',
			add_x: 'カテゴリを追加'
		}
	},
	indicator_category: {
		name: 'カテゴリ',
		name_plural: 'カテゴリ',
		fields: {
			name: '名前'
		},
		messages: {
			delete_confirmation: 'カテゴリを削除',
			delete_confirmation_explanation:
				'このカテゴリを削除してもよろしいですか？この操作は取り消せません。',
			no_x: 'カテゴリなし',
			unassigned: '未割り当て'
		},
		default_values: {
			name: {
				1: '財務',
				2: '顧客',
				3: '業務プロセス',
				4: '学習と成長'
			}
		},
		actions: {
			create_new: '新しいカテゴリを作成',
			edit: 'カテゴリを編集',
			delete: 'カテゴリを削除',
			add_x: 'カテゴリを追加'
		}
	},
};
